import { render, staticRenderFns } from "./set-cover.vue?vue&type=template&id=1cedc7fa"
import script from "./set-cover.vue?vue&type=script&lang=js"
export * from "./set-cover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports